import React from "react";
import { MoonLoader } from "react-spinners";

export default function Loader({ loading, size, color }) {
  return (
    // <div className="digits">
    //   {/* D */}
    //   <svg
    //     className="digit"
    //     viewBox="-20 -20 140 240"
    //     width="50"
    //     height="150"
    //     strokeWidth="20"
    //     fill="none"
    //     style={{ "--color": "#2557a7", "--i": "0" }}>
    //     <circle
    //       r="20"
    //       cx="25"
    //       cy="150"
    //       strokeWidth="10"
    //       pathLength="1"></circle>
    //     <path
    //       d="M0 70V0h25.2c7.3 0 13.5 2.5 18.4 7.4S51 18.5 51 25.8v18.4c0 7.3-2.5 13.5-7.4 18.4S32.5 70 25.2 70H0zm9.5-8.2h15.7c5.3 0 9.8-1.8 13.4-5.4s5.4-8.1 5.4-13.4V25.8c0-5.3-1.8-9.8-5.4-13.4S30.5 7 25.2 7H9.5v54.8z"
    //       strokeWidth="12"></path>
    //   </svg>

    //   {/* E */}
    //   <svg
    //     className="digit"
    //     viewBox="-20 -20 140 240"
    //     width="50"
    //     height="150"
    //     strokeWidth="20"
    //     fill="none"
    //     style={{ "--color": "#1e88e5", "--i": "1" }}>
    //     <circle
    //       r="20"
    //       cx="25"
    //       cy="150"
    //       strokeWidth="10"
    //       pathLength="1"></circle>
    //     <path
    //       d="M42 70L0 70L0 0L42 0L42 8.2L9.5 8.2L9.5 29.5L37.5 29.5L37.5 37.5L9.5 37.5L9.5 61.8L42 61.8L42 70Z"
    //       strokeWidth="12"></path>
    //   </svg>

    //   {/* E */}
    //   <svg
    //     className="digit"
    //     viewBox="-20 -20 140 240"
    //     width="50"
    //     height="150"
    //     strokeWidth="20"
    //     fill="none"
    //     style={{ "--color": "#1976d2", "--i": "2" }}>
    //     <circle
    //       r="20"
    //       cx="25"
    //       cy="150"
    //       strokeWidth="10"
    //       pathLength="1"></circle>
    //     <path
    //       d="M42 70L0 70L0 0L42 0L42 8.2L9.5 8.2L9.5 29.5L37.5 29.5L37.5 37.5L9.5 37.5L9.5 61.8L42 61.8L42 70Z"
    //       strokeWidth="12"></path>
    //   </svg>

    //   {/* P */}
    //   <svg
    //     className="digit"
    //     viewBox="-20 -20 140 240"
    //     width="50"
    //     height="150"
    //     strokeWidth="20"
    //     fill="none"
    //     style={{ "--color": "#1565c0", "--i": "3" }}>
    //     <circle
    //       r="20"
    //       cx="25"
    //       cy="150"
    //       strokeWidth="10"
    //       pathLength="1"></circle>
    //     <path
    //       d="M0 70V0h25.2c7.3 0 13.5 2.5 18.4 7.4S51 18.5 51 25.8v8.4c0 7.3-2.5 13.5-7.4 18.4S32.5 60 25.2 60H9.5v10H0zm9.5-18.2h15.7c5.3 0 9.8-1.8 13.4-5.4s5.4-8.1 5.4-13.4v-8.4c0-5.3-1.8-9.8-5.4-13.4S30.5 7 25.2 7H9.5v44.8z"
    //       strokeWidth="12"></path>
    //   </svg>

    //   {/* H */}
    //   <svg
    //     className="digit"
    //     viewBox="-20 -20 140 240"
    //     width="50"
    //     height="150"
    //     strokeWidth="20"
    //     fill="none"
    //     style={{ "--color": "#0d47a1", "--i": "4" }}>
    //     <circle
    //       r="20"
    //       cx="25"
    //       cy="150"
    //       strokeWidth="10"
    //       pathLength="1"></circle>
    //     <path
    //       d="M0 70V0h9.5v30h33V0H52v70h-9.5V38h-33v32H0z"
    //       strokeWidth="12"></path>
    //   </svg>

    //   {/* I */}
    //   <svg
    //     className="digit"
    //     viewBox="-20 -20 140 240"
    //     width="50"
    //     height="150"
    //     strokeWidth="20"
    //     fill="none"
    //     style={{ "--color": "#2557a7", "--i": "5" }}>
    //     <circle
    //       r="20"
    //       cx="25"
    //       cy="150"
    //       strokeWidth="10"
    //       pathLength="1"></circle>
    //     <path d="M0 70V0h9.5v70H0z" strokeWidth="12"></path>
    //   </svg>

    //   {/* R */}
    //   <svg
    //     className="digit"
    //     viewBox="-20 -20 140 240"
    //     width="50"
    //     height="150"
    //     strokeWidth="20"
    //     fill="none"
    //     style={{ "--color": "#1e88e5", "--i": "6" }}>
    //     <circle
    //       r="20"
    //       cx="25"
    //       cy="150"
    //       strokeWidth="10"
    //       pathLength="1"></circle>
    //     <path
    //       d="M0 70V0h25c7.3 0 13.5 2.5 18.4 7.4S51 18.5 51 25.8v8.4c0 6-1.7 11.2-5.1 15.6c-3.4 4.4-7.9 7.1-13.5 8.1L51 70h-11L22.5 49.8H9.5V70H0zm9.5-28.2h15.5c5.3 0 9.8-1.8 13.4-5.4s5.4-8.1 5.4-13.4v-8.4c0-5.3-1.8-9.8-5.4-13.4S30.3 7 25 7H9.5v34.8z"
    //       strokeWidth="12"></path>
    //   </svg>

    //   {/* E */}
    //   <svg
    //     className="digit"
    //     viewBox="-20 -20 140 240"
    //     width="50"
    //     height="150"
    //     strokeWidth="20"
    //     fill="none"
    //     style={{ "--color": "#1976d2", "--i": "7" }}>
    //     <circle
    //       r="20"
    //       cx="25"
    //       cy="150"
    //       strokeWidth="10"
    //       pathLength="1"></circle>
    //     <path
    //       d="M42 70L0 70L0 0L42 0L42 8.2L9.5 8.2L9.5 29.5L37.5 29.5L37.5 37.5L9.5 37.5L9.5 61.8L42 61.8L42 70Z"
    //       strokeWidth="12"></path>
    //   </svg>
    // </div>
    <div className="digits">
      <MoonLoader loading={loading} size={size} color={color} />
    </div>
  );
}
